__turbopack_context__.v({
  "button": "MainBox-module__RbOaqG__button",
  "image": "MainBox-module__RbOaqG__image",
  "main": "MainBox-module__RbOaqG__main",
});
